//@flow

var _paramREs = {};

function getUrlParam(name/*:string*/, url/*:?string*/)/*:?string*/ {
  var re = _paramREs[name];
  if ( !re ) {
    var safeName = name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    re = new RegExp('(?:^|&)'+safeName+'=([^&]+)');
    _paramREs[name] = re;
  }
  url = url!=null ? url.split('#')[0].split('?')[1] : document.location.search.substr(1);
  return ( re.exec(url) || [] )[1];
}

module.exports = getUrlParam;



//////////////////
// WEBPACK FOOTER
// ./node_modules/qj/getUrlParam.js
// module id = 98
// module chunks = 0